module.exports = "<div md-whiteframe=\"1\" class=\"content-box text-center\">\n  <h1>{{ \"USERS.CLIENT_ACTIVATION.GREETINGS\" | translate:{name: userName} }}</h1>\n  <p>{{ \"USERS.CLIENT_ACTIVATION.INFO\" | translate }}</p>\n  <!-- <p><a ui-sref=\"public.users.client.client-login\"><img class=\"round\" alt=\"F&F\" src=\"http://placehold.it/150x150\"></a></p> -->\n\n  <button type=\"button\" class=\"md-button md-raised md-primary\" ui-sref=\"public.users.login\">\n    {{ 'COMMONS.LOGIN' | translate }}\n  </button>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/users/client/client-activation-confirm.html
// module id = 233
// module chunks = 0